export class TicketNote {
  id = null;
  ticket_id = null;
  user_id = null;
  comment = null;
  file_one_original_name = null;
  file_one_modified_name = null;
  file_two_original_name = null;
  file_two_modified_name = null;
}
